import ViolationsTabDetailsFooter from './ViolationsTabDetailsFooter';

export default ViolationsTabDetailsFooter;
